import clsx from 'clsx'
import React, { FC, ReactElement } from 'react'

import styles from './arrow.module.scss'

interface Props {
  className?: string
  direction?: 'left' | 'right'
  onClick?: (event) => void
  svg: ReactElement
}

export const Arrow: FC<Props> = ({ direction = 'right', className, onClick = undefined, svg }) => (
  <div className={clsx(styles.arrow, className, direction === 'right' ? styles.right : styles.left)} onClick={onClick}>
    {svg}
  </div>
)
